<template>
  <div class="systemMContainer">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.systemMContainer{
  height: 100%;
}
</style>
